export const HEADERS = [
  { label: "หมายเลขเครื่องตัด", key: "deviceID" },
  { label: "หมายเลขรหัส PL", key: "deviceLotID" },
  { label: "รหัสลูกค้า", key: "customerCode" },
  { label: "ลักษณะเครื่อง", key: "deviceType" },
  { label: "ขนาดเครื่อง", key: "deviceSize" },
  { label: "วันที่สร้าง", key: "createDate" },
  { label: "Bluetooth", key: "bluetooth" },
  { label: "Proxy", key: "proxy" },
  { label: "Group", key: "groupName" },
  { label: "Version", key: "version" },
  { label: "Lot/เดือน", key: "lotMonth" },
  { label: "สถานะ", key: "deviceStatus" },
  { label: "สถานะเครื่อง", key: "extDeviceStatusName" },
  { label: "เปิด-ปิด", key: "isAvailableName" },
  { label: "หมายเหตุ", key: "remark" },
];
